(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["available-offers"] && !Shopify.designMode) return;
  try {
    class AvailableOffers extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-avo-track]');
      this.prev = this.querySelector('[data-avo-prev]');
      this.next = this.querySelector('[data-avo-next]');

      if (this.track) {
        this.onScroll = this.syncArrows.bind(this);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });

        if (this.prev) this.prev.addEventListener('click', () => this.step(-1));
        if (this.next) this.next.addEventListener('click', () => this.step(1));

        if ('ResizeObserver' in window) {
          this.observer = new ResizeObserver(this.onScroll);
          this.observer.observe(this.track);
        }
        this.syncArrows();
      }

      this.onCopy = this.handleCopy.bind(this);
      this.addEventListener('click', this.onCopy);
    }

    disconnectedCallback() {
      if (this.track && this.onScroll) this.track.removeEventListener('scroll', this.onScroll);
      if (this.observer) this.observer.disconnect();
      this.removeEventListener('click', this.onCopy);
      if (this.copyTimer) clearTimeout(this.copyTimer);
    }

    step(direction) {
      // One card short of a full view keeps the card being read partly on screen,
      // so the shopper does not lose their place.
      const card = this.track.querySelector('.avo__item');
      // The gap is a setting now, so it is read rather than assumed.
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const amount = card ? card.getBoundingClientRect().width + gap : this.track.clientWidth;
      this.track.scrollBy({ left: direction * amount, behavior: 'smooth' });
    }

    syncArrows() {
      if (!this.prev || !this.next) return;

      // scrollLeft runs negative in right-to-left documents, so distances are
      // measured in absolute terms and the ends are decided from those.
      const max = Math.round(this.track.scrollWidth - this.track.clientWidth);
      const pos = Math.round(Math.abs(this.track.scrollLeft));

      // The track carries a little padding so card shadows are not clipped, and
      // scroll-snap settles a couple of pixels inside it, so a strict comparison
      // against zero never reports the start. A few pixels either way is not
      // something a shopper can act on.
      const EDGE = 8;

      // Too little to scroll for an arrow to be worth showing.
      if (max <= EDGE * 2) {
        this.prev.hidden = true;
        this.next.hidden = true;
        return;
      }

      this.prev.hidden = pos <= EDGE;
      this.next.hidden = pos >= max - EDGE;
    }

    handleCopy(event) {
      const button = event.target.closest('[data-avo-copy]');
      if (!button || !this.contains(button)) return;

      const code = button.getAttribute('data-avo-copy');
      if (!code) return;

      const done = () => {
        button.textContent = button.getAttribute('data-copied-label') || 'Copied';
        button.setAttribute('data-copied', '');
        if (this.copyTimer) clearTimeout(this.copyTimer);
        this.copyTimer = setTimeout(() => {
          button.textContent = button.getAttribute('data-copy-label') || 'Copy';
          button.removeAttribute('data-copied');
        }, 2000);
      };

      // navigator.clipboard is unavailable on insecure origins and in some
      // in-app browsers, so fall back to a selection-based copy.
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(code).then(done).catch(() => this.legacyCopy(code, done));
      } else {
        this.legacyCopy(code, done);
      }
    }

    legacyCopy(code, done) {
      const field = document.createElement('textarea');
      field.value = code;
      field.setAttribute('readonly', '');
      field.style.cssText = 'position:fixed;top:-1000px;opacity:0';
      document.body.appendChild(field);
      field.select();
      try {
        document.execCommand('copy');
        done();
      } catch (e) {
        /* leave the button as it is; the code is on screen to read */
      }
      document.body.removeChild(field);
    }
  }

  if (!customElements.get('available-offers')) {
    customElements.define('available-offers', AvailableOffers);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-goal-bar"] && !Shopify.designMode) return;
  try {
    class CartGoal extends HTMLElement {
    connectedCallback() {
      try {
        this.tiers = JSON.parse(this.dataset.tiers || '[]');
      } catch (e) {
        this.tiers = [];
      }
      this.textEl = this.querySelector('[data-cgb-text]');
      this.fillEl = this.querySelector('[data-cgb-fill]');
      this.trackEl = this.querySelector('[role="progressbar"]');

      // Liquid has already drawn the correct state for the cart as it was when
      // the page was served. The only job here is to keep it true afterwards.
      //
      // Shopify serves this bundle ahead of the theme's own scripts, and all of
      // them are deferred, so subscribe() genuinely does not exist yet while
      // the element is upgrading. readyState is no help: it already reads
      // "interactive" while deferred scripts are still running. What the
      // component actually depends on is checked instead.
      this.bind = this.bind.bind(this);
      if (this.themeReady()) {
        this.bind();
      } else {
        document.addEventListener('DOMContentLoaded', this.bind, { once: true });
        window.addEventListener('load', this.bind, { once: true });
      }

      // Coming back through the history cache can restore a page whose cart
      // has since moved on elsewhere.
      this.onShow = (event) => {
        if (event.persisted) this.refetch();
      };
      window.addEventListener('pageshow', this.onShow);
    }

    themeReady() {
      return (
        typeof subscribe === 'function' &&
        !!window.Shopify &&
        typeof window.Shopify.formatMoney === 'function'
      );
    }

    bind() {
      // Two listeners lead here and a late upgrade may find the page ready, so
      // this has to be safe to reach more than once.
      if (this.bound) return;
      this.bound = true;

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          const total = event && event.cartData && event.cartData.total_price;
          if (typeof total === 'number') {
            this.render(total);
          } else {
            this.scheduleRefetch();
          }
        });
      }

      // cart-update is published by the product form and by nothing else, so a
      // quantity edit or a removal in the drawer would never reach it. Every
      // one of those does rewrite the header count, which makes that element a
      // dependable second signal for any change at all.
      const badge = document.querySelector('.cart-count');
      if (badge && 'MutationObserver' in window) {
        this.observer = new MutationObserver(() => this.scheduleRefetch());
        this.observer.observe(badge, { childList: true, characterData: true, subtree: true });
      }
    }

    // Both signals can land for one change, and the theme rewrites the badge
    // more than once per update, so the fetch is collapsed.
    scheduleRefetch() {
      clearTimeout(this.refetchTimer);
      this.refetchTimer = setTimeout(() => this.refetch(), 150);
    }

    disconnectedCallback() {
      document.removeEventListener('DOMContentLoaded', this.bind);
      window.removeEventListener('load', this.bind);
      if (this.unsubscribe) this.unsubscribe();
      if (this.observer) this.observer.disconnect();
      clearTimeout(this.refetchTimer);
      window.removeEventListener('pageshow', this.onShow);
    }

    refetch() {
      fetch(window.Shopify.routes.root + 'cart.js')
        .then((r) => r.json())
        .then((cart) => this.render(cart.total_price))
        .catch(() => {
          /* leave the served state on screen; it is not worth an error here */
        });
    }

    // A store's money format may carry markup of its own, which Liquid drops
    // with strip_html on the first paint. The same is done here so the two
    // renderings cannot disagree.
    money(cents) {
      const format = window.cartStrings && window.cartStrings.money_format;
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && format) {
        const div = document.createElement('div');
        div.innerHTML = window.Shopify.formatMoney(cents, format);
        return div.textContent;
      }
      return (cents / 100).toFixed(2);
    }

    // Reward text is merchant-entered and ends up inside innerHTML, so it is
    // escaped here exactly as Liquid escapes it on the first paint.
    escape(value) {
      const div = document.createElement('div');
      div.textContent = value == null ? '' : String(value);
      return div.innerHTML;
    }

    render(total) {
      if (!this.tiers.length || !this.textEl || !this.fillEl) return;

      const next = this.tiers.find((t) => total < t.amount);
      let percent;
      let message;

      if (next) {
        percent = Math.min(100, Math.round((total / next.amount) * 100));
        message = (this.dataset.tplRemaining || '')
          .replace('[[amount]]', '<b>' + this.escape(this.money(next.amount - total)) + '</b>')
          .replace('[[reward]]', '<b>' + this.escape(next.reward) + '</b>');
      } else {
        percent = 100;
        const top = this.tiers[this.tiers.length - 1];
        message = (this.dataset.tplUnlocked || '').replace(
          '[[reward]]',
          '<b>' + this.escape(top ? top.reward : '') + '</b>'
        );
      }

      this.textEl.innerHTML = message;
      this.fillEl.style.width = percent + '%';
      if (this.trackEl) this.trackEl.setAttribute('aria-valuenow', String(percent));
    }
  }

  if (!customElements.get('cart-goal')) {
    customElements.define('cart-goal', CartGoal);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["complete-the-look"] && !Shopify.designMode) return;
  try {
    class CompleteLook extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-ctl-form]');
      this.button = this.querySelector('[data-ctl-button]');
      this.totalEl = this.querySelector('[data-ctl-total]');
      this.badgeEl = this.querySelector('[data-ctl-badge]');
      this.errorEl = this.querySelector('[data-ctl-error]');
      this.thisId = this.querySelector('[data-ctl-this-id]');
      this.thisPriceEl = this.querySelector('[data-ctl-this-price]');
      this.allLink = this.querySelector('[data-ctl-all]');
      this.noteEl = this.querySelector('[data-ctl-note]');
      this.checks = Array.from(this.querySelectorAll('.ctl__check'));

      // Liquid has already priced the viewed product; this only has to follow
      // the shopper from here.
      const d = this.thisPriceEl ? this.thisPriceEl.dataset : {};
      this.thisPrice = parseInt(d.ctlThisPrice, 10) || 0;
      this.thisWas = parseInt(d.ctlThisWas, 10) || this.thisPrice;
      this.thisAvailable = true;
      this.thisImage = this.querySelector('.ctl__card--this .ctl__img');

      try {
        this.variants = JSON.parse(this.dataset.variants || '{}');
      } catch (e) {
        this.variants = {};
      }
      this.onVariant = this.onVariantInput.bind(this);
      document.addEventListener('change', this.onVariant);

      this.onToggle = () => this.render();
      this.checks.forEach((c) => c.addEventListener('change', this.onToggle));

      this.onSubmit = this.handleSubmit.bind(this);
      if (this.form) this.form.addEventListener('submit', this.onSubmit);

      this.onSelectAll = () => {
        this.checks.forEach((c) => {
          c.checked = true;
        });
        this.render();
      };
      if (this.allLink) this.allLink.addEventListener('click', this.onSelectAll);

      // This bundle is served ahead of the theme's own scripts, and all of them
      // are deferred, so neither subscribe() nor Shopify.formatMoney exists yet
      // while the element upgrades. readyState is no help here: it already
      // reads "interactive" while deferred scripts are still running. What the
      // component actually depends on is checked instead.
      this.bind = this.bind.bind(this);
      if (this.themeReady()) {
        this.bind();
      } else {
        document.addEventListener('DOMContentLoaded', this.bind, { once: true });
        window.addEventListener('load', this.bind, { once: true });
      }

      // No first render here on purpose. Liquid has already painted every
      // figure correctly, and Shopify.formatMoney — which lives in the theme's
      // own bundle, served after this one — is not defined yet. Rendering now
      // would fall back to a bare number and strip the currency symbol off a
      // total that was right to begin with.
    }

    disconnectedCallback() {
      this.checks.forEach((c) => c.removeEventListener('change', this.onToggle));
      if (this.form) this.form.removeEventListener('submit', this.onSubmit);
      if (this.allLink) this.allLink.removeEventListener('click', this.onSelectAll);
      document.removeEventListener('change', this.onVariant);
      document.removeEventListener('DOMContentLoaded', this.bind);
      window.removeEventListener('load', this.bind);
      if (this.unsubscribe) this.unsubscribe();
      if (this.unsubAdd) this.unsubAdd();
    }

    themeReady() {
      return (
        typeof subscribe === 'function' &&
        !!window.Shopify &&
        typeof window.Shopify.formatMoney === 'function'
      );
    }

    bind() {
      // Two listeners lead here and a late upgrade may find the page ready, so
      // this has to be safe to reach more than once.
      if (this.bound) return;
      this.bound = true;

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object') {
        // A shopper who ticks a piece and then presses the product's own Add to
        // cart means both. That button belongs to the theme and carries a
        // third-party express checkout, so it is not intercepted; the panel
        // waits for the add it announces and sends the ticked pieces after it.
        this.unsubAdd = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (!event || event.source !== 'product-form') return;
          this.attachPieces();
        });
      }

      // Safe to render from here: every deferred script has run, so the
      // theme's money formatter is in place.
      this.render();
    }

    // The theme signals a variant change by writing the new id into the product
    // form and firing a bubbling change on that input — PUB_SUB_EVENTS carries
    // a variantChange name but nothing in this theme ever publishes it, so
    // subscribing to it watched an event that never arrives. Listening on the
    // document and recognising the id keeps this free of any assumption about
    // which form or section the picker belongs to, and a quick view of some
    // other product is ignored because its ids are not in this table.
    onVariantInput(event) {
      const input = event.target;
      if (!input || input.name !== 'id' || this.contains(input)) return;

      const variant = this.variants[String(input.value)];
      if (!variant) return;

      if (this.thisId) this.thisId.value = input.value;
      this.thisPrice = variant.price;
      this.thisWas = variant.was > variant.price ? variant.was : variant.price;
      this.thisAvailable = variant.available !== false;

      if (this.thisPriceEl) this.thisPriceEl.textContent = this.money(variant.price);

      // A variant with a picture of its own would otherwise leave the card
      // showing the wrong one.
      if (variant.image && this.thisImage) {
        this.thisImage.src = variant.image;
        this.thisImage.removeAttribute('srcset');
        this.thisImage.removeAttribute('sizes');
      }

      this.render();
    }

    root() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    cartElement() {
      return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    }

    sectionsToRender() {
      const cart = this.cartElement();
      if (!cart || typeof cart.getSectionsToRender !== 'function') return null;
      const sections = cart.getSectionsToRender();
      return sections && sections.length ? sections : null;
    }

    // Asking for the cart sections alongside the add is what lets the mini cart
    // be redrawn from the server rather than left holding the markup it was
    // served with.
    askForSections(target) {
      const sections = this.sectionsToRender();
      if (!sections) return null;
      const ids = sections.map((section) => section.id);
      if (target instanceof FormData) {
        target.append('sections', ids);
        target.append('sections_url', window.location.pathname);
      } else {
        target.sections = ids;
        target.sections_url = window.location.pathname;
      }
      return sections;
    }

    // The theme redraws its mini cart from the response and then opens it. An
    // add that skips this leaves the drawer showing the cart as it was when the
    // page loaded — which is how it came to open empty with a full count badge
    // beside it.
    syncCart(response, open) {
      const cart = this.cartElement();
      const sections = this.sectionsToRender();
      if (!cart || !sections || !response || !response.sections) return;

      sections.forEach((section) => {
        const target = document.getElementById(section.id);
        const parsed = new DOMParser().parseFromString(
          response.sections[section.id] || '',
          'text/html'
        );
        const source = parsed.querySelector('#minicart-form');
        if (target && source) target.innerHTML = source.innerHTML;
      });

      if (typeof cart.cartAction === 'function') cart.cartAction();
      cart.classList.remove('is-empty');

      if (open && typeof cart.open === 'function') {
        // The cart page has no drawer to open, and the theme skips it there too.
        if (!document.body.classList.contains('template-cart')) cart.open();
      }
    }

    // A store's money format may carry markup of its own, which Liquid drops
    // with strip_html on the first paint. The same is done here.
    money(cents) {
      const format = window.cartStrings && window.cartStrings.money_format;
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && format) {
        const div = document.createElement('div');
        div.innerHTML = window.Shopify.formatMoney(cents, format);
        return div.textContent;
      }
      return (cents / 100).toFixed(2);
    }

    render() {
      let total = this.thisPrice;
      let was = this.thisWas;
      let picked = 1;

      this.checks.forEach((check) => {
        const card = check.closest('.ctl__card');
        const inputs = card ? card.querySelectorAll('input[type="hidden"]') : [];
        // A disabled field is not serialised, which is what keeps an unticked
        // piece out of the request without rebuilding the form.
        inputs.forEach((i) => {
          i.disabled = !check.checked;
        });
        if (!check.checked) return;

        picked += 1;
        const price = parseInt(check.dataset.ctlPrice, 10) || 0;
        const listed = parseInt(check.dataset.ctlWas, 10) || 0;
        total += price;
        was += listed > price ? listed : price;
      });

      if (this.totalEl) this.totalEl.textContent = this.money(total);

      if (this.badgeEl) {
        const saving = was - total;
        this.badgeEl.hidden = saving <= 0;
        if (saving > 0) {
          this.badgeEl.textContent = (this.dataset.tplSaving || '').replace(
            '[[amount]]',
            this.money(saving)
          );
        }
      }

      // The button always says what pressing it will do. Nothing ticked and
      // there is nothing to add yet, so it offers to gather the look; the
      // moment a piece is ticked it becomes the add, whether or not the whole
      // look is chosen. Leaving it on "select" until every box was ticked was
      // a dead end: a shopper who wanted two pieces had no way to say so.
      const anyTicked = picked > 1;
      const everything = this.checks.every((c) => c.checked);

      if (this.button) {
        this.button.textContent = anyTicked
          ? (this.dataset.tplAdd || '').replace('[[count]]', String(picked))
          : this.dataset.selectLabel || '';
        this.button.dataset.ctlMode = anyTicked ? 'add' : 'select';

        // The set is part of every add, so a sold-out variant makes the add
        // impossible. Gathering the look is only ticking boxes and stays
        // available.
        this.button.disabled = anyTicked && !this.thisAvailable;
      }

      // Gathering the rest stays available while the button is busy adding.
      if (this.allLink) this.allLink.hidden = !anyTicked || everything;
      if (this.noteEl) this.noteEl.hidden = !anyTicked;
    }

    // Sends whatever is ticked and clears the ticks, because those pieces are
    // in the cart now. They are cleared before the request rather than after,
    // so a second cart-update for the same add finds nothing left to send.
    attachPieces() {
      const picked = this.checks.filter((c) => c.checked);
      if (!picked.length) return;

      const items = picked
        .map((check) => {
          const card = check.closest('.ctl__card');
          const field = card && card.querySelector('input[name="items[][id]"]');
          return field ? { id: Number(field.value), quantity: 1 } : null;
        })
        .filter(Boolean);
      if (!items.length) return;

      picked.forEach((c) => {
        c.checked = false;
      });
      this.render();

      const payload = { items: items };
      this.askForSections(payload);

      fetch(this.root() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload),
      })
        .then((response) =>
          response.json().then((data) => {
            if (!response.ok) throw new Error(data.description || data.message || '');
            return data;
          })
        )
        .then((data) => {
          // The theme has already opened the drawer for its own add; this only
          // has to put the pieces into what it is showing.
          this.syncCart(data, false);
          return this.refresh();
        })
        .catch((error) => {
          // Put the ticks back so the panel still matches what is in the cart.
          picked.forEach((c) => {
            c.checked = true;
          });
          this.render();
          this.setError(error.message);
        });
    }

    handleSubmit(event) {
      event.preventDefault();
      if (this.button && this.button.dataset.ctlMode === 'select') {
        this.checks.forEach((c) => {
          c.checked = true;
        });
        this.render();
        return;
      }

      this.setError('');
      this.button.disabled = true;

      const body = new FormData(this.form);
      this.askForSections(body);

      fetch(this.root() + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: body,
      })
        .then((response) =>
          response.json().then((data) => {
            if (!response.ok) throw new Error(data.description || data.message || '');
            return data;
          })
        )
        .then((data) => {
          // This add is the shopper's whole action, so the drawer opens, just
          // as it does for the product's own button.
          this.syncCart(data, true);
          // Those pieces are in the cart now, so the ticks come off. Leaving
          // them on would send them a second time with the next add.
          this.checks.forEach((c) => {
            c.checked = false;
          });
          this.render();
          return this.refresh();
        })
        .catch((error) => this.setError(error.message))
        .then(() => {
          this.button.disabled = false;
        });
    }

    setError(message) {
      if (!this.errorEl) return;
      this.errorEl.textContent = message || '';
      this.errorEl.hidden = !message;
    }

    // Exactly the refresh the theme performs after its own adds, so the count,
    // the header total and the existing shipping bar all stay truthful.
    refresh() {
      return fetch(this.root() + 'cart.js')
        .then((r) => r.json())
        .then((cart) => {
          if (cart.item_count === undefined) return;

          document.querySelectorAll('.cart-count').forEach((el) => {
            if (el.classList.contains('cart-count-drawer')) {
              el.innerHTML = '(' + cart.item_count + ')';
            } else {
              el.innerHTML = cart.item_count > 100 ? '~' : cart.item_count;
            }
          });

          const headerTotal = document.querySelector('header-total-price');
          if (headerTotal && typeof headerTotal.updateTotal === 'function') {
            headerTotal.updateTotal(cart);
          }

          const shippingBar = document.querySelector('free-ship-progress-bar');
          if (shippingBar && typeof shippingBar.init === 'function') {
            shippingBar.init(cart.items_subtotal_price);
          }

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS === 'object') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'complete-the-look', cartData: cart });
          }
        })
        .catch(() => {
          /* the cart itself is already correct; only the badges lag */
        });
    }
  }

  if (!customElements.get('complete-look')) {
    customElements.define('complete-look', CompleteLook);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["international-order-button"] && !Shopify.designMode) return;
  try {
    class InternationalOrder extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-intl-order-button]');
      this.label = this.querySelector('[data-intl-order-label]');
      this.errorEl = this.querySelector('[data-intl-order-error]');
      this.form = document.getElementById(this.dataset.formId);
      if (!this.button || !this.form) return;

      this.idleLabel = this.label ? this.label.textContent : '';
      this.button.addEventListener('click', this.onClick.bind(this));
    }

    get root() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    setBusy(isBusy) {
      this.button.setAttribute('aria-busy', String(isBusy));
      this.button.disabled = isBusy;
    }

    showError(message) {
      if (!this.errorEl) return;
      this.errorEl.textContent = message;
      this.errorEl.hidden = !message;
    }

    async onClick() {
      if (this.button.disabled) return;
      this.showError('');
      this.setBusy(true);

      try {
        const body = new FormData(this.form);
        // The theme's product form carries a return_to for its own flow; this
        // button decides its own destination, so drop it before posting.
        body.delete('return_to');

        const response = await fetch(this.root + 'cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: body,
        });

        if (!response.ok) {
          const data = await response.json().catch(() => ({}));
          this.showError(data.description || data.message || this.dataset.errorText || 'Could not add this item.');
          this.setBusy(false);
          return;
        }

        window.location.href = this.root + 'checkout';
      } catch (error) {
        this.showError(this.dataset.errorText || 'Something went wrong. Please try again.');
        this.setBusy(false);
      }
    }
  }

  if (!customElements.get('international-order')) {
    customElements.define('international-order', InternationalOrder);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["paid-extras"] && !Shopify.designMode) return;
  try {
    class PaidExtras extends HTMLElement {
    connectedCallback() {
      this.checks = Array.from(this.querySelectorAll('[data-addon-variant]'));
      this.errorEl = this.querySelector('[data-pxt-error]');
      this.keys = {};

      // Liquid has already ticked whatever is in the cart and handed over the
      // line key needed to take it out again, so there is nothing to fetch.
      this.checks.forEach((c) => {
        if (c.dataset.lineKey) this.keys[String(c.dataset.addonVariant)] = c.dataset.lineKey;
      });

      this.onChange = this.handleChange.bind(this);
      this.checks.forEach((c) => c.addEventListener('change', this.onChange));

      // The one case Liquid cannot cover: a page restored from the back-forward
      // cache is the old render, and the cart may have moved on since.
      this.onShow = (event) => {
        if (event.persisted) this.sync();
      };
      window.addEventListener('pageshow', this.onShow);
    }

    disconnectedCallback() {
      this.checks.forEach((c) => c.removeEventListener('change', this.onChange));
      window.removeEventListener('pageshow', this.onShow);
    }

    root() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    sync() {
      fetch(this.root() + 'cart.js')
        .then((r) => r.json())
        .then((cart) => {
          this.checks.forEach((check) => {
            const id = String(check.dataset.addonVariant);
            const line = (cart.items || []).find((i) => String(i.variant_id) === id);
            check.checked = !!line;
            if (line) {
              this.keys[id] = line.key;
            } else {
              delete this.keys[id];
            }
          });
        })
        .catch(() => {
          /* the boxes simply stay as served */
        });
    }

    handleChange(event) {
      const check = event.target;
      const id = String(check.dataset.addonVariant);
      const row = check.closest('.pxt__row');
      this.setError('');
      if (row) row.setAttribute('data-busy', '');
      check.disabled = true;

      const done = () => {
        if (row) row.removeAttribute('data-busy');
        check.disabled = false;
      };

      const failed = (message) => {
        // Put the box back where it was, so it never disagrees with the cart.
        check.checked = !check.checked;
        this.setError(message);
        done();
      };

      if (check.checked) {
        this.post(this.root() + 'cart/add.js', { id: id, quantity: 1 })
          .then((data) => {
            const item = data && (data.items ? data.items[0] : data);
            if (item && item.key) this.keys[id] = item.key;
            this.syncCart(data);
            this.refresh();
            done();
          })
          .catch((error) => failed(error.message));
      } else {
        const key = this.keys[id];
        if (!key) {
          this.sync();
          done();
          return;
        }
        this.post(this.root() + 'cart/change.js', { id: key, quantity: 0 })
          .then((data) => {
            delete this.keys[id];
            this.syncCart(data);
            this.refresh();
            done();
          })
          .catch((error) => failed(error.message));
      }
    }

    cartElement() {
      return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    }

    sectionsToRender() {
      const cart = this.cartElement();
      if (!cart || typeof cart.getSectionsToRender !== 'function') return null;
      const sections = cart.getSectionsToRender();
      return sections && sections.length ? sections : null;
    }

    // The theme redraws its mini cart from the server after every change. A
    // change that skips this leaves the drawer holding the markup the page was
    // served with, so it can open showing a cart that is out of date.
    syncCart(response) {
      const cart = this.cartElement();
      const sections = this.sectionsToRender();
      if (!cart || !sections || !response || !response.sections) return;

      sections.forEach((section) => {
        const target = document.getElementById(section.id);
        const parsed = new DOMParser().parseFromString(
          response.sections[section.id] || '',
          'text/html'
        );
        const source = parsed.querySelector('#minicart-form');
        if (target && source) target.innerHTML = source.innerHTML;
      });

      if (typeof cart.cartAction === 'function') cart.cartAction();
      cart.classList.remove('is-empty');
      // No open() here: ticking an extra is a small adjustment, and a drawer
      // sliding out over the page on every tick would be in the way.
    }

    post(url, body) {
      const sections = this.sectionsToRender();
      if (sections) {
        body.sections = sections.map((section) => section.id);
        body.sections_url = window.location.pathname;
      }
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      }).then((response) => {
        return response.json().then((data) => {
          if (!response.ok) {
            throw new Error(data.description || data.message || '');
          }
          return data;
        });
      });
    }

    setError(message) {
      if (!this.errorEl) return;
      this.errorEl.textContent = message || '';
      this.errorEl.hidden = !message;
    }

    // Exactly the refresh the theme performs after its own adds, so the count,
    // the header total and the existing shipping bar all stay truthful.
    refresh() {
      fetch(this.root() + 'cart.js')
        .then((r) => r.json())
        .then((cart) => {
          if (cart.item_count === undefined) return;

          document.querySelectorAll('.cart-count').forEach((el) => {
            if (el.classList.contains('cart-count-drawer')) {
              el.innerHTML = '(' + cart.item_count + ')';
            } else {
              el.innerHTML = cart.item_count > 100 ? '~' : cart.item_count;
            }
          });

          const headerTotal = document.querySelector('header-total-price');
          if (headerTotal && typeof headerTotal.updateTotal === 'function') {
            headerTotal.updateTotal(cart);
          }

          const shippingBar = document.querySelector('free-ship-progress-bar');
          if (shippingBar && typeof shippingBar.init === 'function') {
            shippingBar.init(cart.items_subtotal_price);
          }

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS === 'object') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'paid-extras',
              cartData: cart,
            });
          }
        })
        .catch(() => {
          /* the cart itself is already correct; only the badges lag */
        });
    }
  }

  if (!customElements.get('paid-extras')) {
    customElements.define('paid-extras', PaidExtras);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pdp-compact-actions"] && !Shopify.designMode) return;
  try {
    class CompactActions extends HTMLElement {
    connectedCallback() {
      try {
        this.prices = JSON.parse(this.dataset.prices || '{}');
      } catch (e) {
        this.prices = {};
      }

      this.scope = this.closest('.product-detail__buy-buttons') || this.parentElement;
      if (!this.scope) return;

      // The class goes on only once the component is alive, so a page whose
      // JavaScript never runs keeps the theme's own stacked buttons rather
      // than a half-applied grid.
      this.scope.classList.add('pdpa-on');

      this.paint(this.currentId());

      this.onVariant = this.handleVariant.bind(this);
      document.addEventListener('change', this.onVariant);

      // Choosing a variant makes the theme redraw this part of the page, which
      // takes the amount with it. Watching the area puts it back rather than
      // leaving the button to say less than it did a moment ago.
      if ('MutationObserver' in window) {
        this.observer = new MutationObserver(() => {
          if (this.amount && this.scope.contains(this.amount)) return;
          this.amount = null;
          this.paint(this.currentId());
        });
        this.observer.observe(this.scope, { childList: true, subtree: true });
      }
    }

    disconnectedCallback() {
      document.removeEventListener('change', this.onVariant);
      if (this.observer) this.observer.disconnect();
      if (this.scope) this.scope.classList.remove('pdpa-on');
    }

    currentId() {
      const input = this.scope.querySelector('input[name="id"]');
      return input ? input.value : null;
    }

    // The theme announces a variant change by writing the id into the product
    // form and firing a bubbling change on that input. Recognising the id
    // rather than the form keeps this clear of quick views of other products.
    handleVariant(event) {
      const input = event.target;
      if (!input || input.name !== 'id') return;
      if (!this.prices[String(input.value)]) return;
      this.paint(input.value);
    }

    paint(id) {
      // Looked up each time: the button itself is replaced when the theme
      // redraws after a variant change, so a reference kept from earlier would
      // point at an element no longer on the page.
      this.button = this.scope && this.scope.querySelector('button[name="add"]');
      if (!this.button) return;
      const price = this.prices[String(id)];
      if (!price) return;

      if (!this.amount || !this.button.contains(this.amount)) {
        this.amount = this.button.querySelector('.pdpa__amount');
      }
      if (!this.amount) {
        // Appended to the label rather than replacing it, so the button keeps
        // whatever wording the theme's translation gives it.
        this.amount = document.createElement('span');
        this.amount.className = 'pdpa__amount';
        const label = this.button.querySelector('span') || this.button;
        label.appendChild(this.amount);
      }
      this.amount.textContent = ' · ' + price;
    }
  }

  if (!customElements.get('compact-actions')) {
    customElements.define('compact-actions', CompactActions);
  }
  } catch(e) { console.error(e); }
})();

})();
